import { useEffect, useRef } from "react";
import { useThemeSwitch } from "sj-ui-toolkit/src/theme";

// these need to match the file names in public/monaco-themes
const darkThemeName = "brilliance-dull";
const lightThemeName = "chrome-devtools";

export const useMonacoThemes = () => {
  const editorRef = useRef(null);
  const monacoRef = useRef(null);

  const { appliedTheme } = useThemeSwitch();
  const monacoTheme = appliedTheme === "atlas-dark" ? darkThemeName : lightThemeName;

  const handleEditorMount = async (editor, monaco) => {
    editorRef.current = editor;
    monacoRef.current = monaco;

    // Set aria-label for the editor's (IME) textarea to improve accessibility
    const textarea = editor.getDomNode()?.querySelector("textarea");
    if (textarea) {
      textarea.setAttribute("aria-label", "Code editor");
    }

    try {
      const [darkResponse, lightResponse] = await Promise.all([
        fetch(`/monaco-themes/${darkThemeName}.json`),
        fetch(`/monaco-themes/${lightThemeName}.json`),
      ]);

      const [darkTheme, lightTheme] = await Promise.all([
        darkResponse.json(),
        lightResponse.json(),
      ]);

      monaco.editor.defineTheme(darkThemeName, darkTheme);
      monaco.editor.defineTheme(lightThemeName, lightTheme);
      monaco.editor.setTheme(monacoTheme);
    } catch (error) {
      console.error("Failed to load Monaco themes:", error);
    }
  };

  useEffect(() => {
    if (monacoRef.current) {
      monacoRef.current.editor.setTheme(monacoTheme);
    }
  }, [monacoTheme]);

  return {
    editorRef,
    monacoTheme,
    handleEditorMount,
  };
};
